import { ReactElement } from "react";
import { t } from "@lingui/core/macro";

import { Button, ButtonGroup } from "_/components/button";
import { Icon } from "_/components/icon";

import * as S from "./styled";

type CursorPagination = {
  currentPage: number;
  canShowNewer: boolean;
  canShowOlder: boolean;
  isPlaceholderData: boolean;
  showNewer: () => void;
  showOlder: () => void;
};

type TablePaginationProps = {
  pagination: CursorPagination;
};

/** Controls for tables backed by cursor-paginated API endpoints. */
export const TablePagination = ({
  pagination: { currentPage, canShowNewer, canShowOlder, showNewer, showOlder },
}: TablePaginationProps): ReactElement | null => {
  if (!canShowNewer && !canShowOlder) {
    return null;
  }

  return (
    <S.Pagination>
      <ButtonGroup>
        <Button
          kind="primary"
          variant="hollow"
          size="small"
          iconOnly
          disabled={!canShowNewer}
          onClick={showNewer}
          title={t`components.table.previous-page`}
        >
          <Icon variant="ChevronLeft" />
        </Button>
        <S.PaginationPage>
          {t`components.table.page ${currentPage}`}
        </S.PaginationPage>
        <Button
          kind="primary"
          variant="hollow"
          size="small"
          iconOnly
          disabled={!canShowOlder}
          onClick={showOlder}
          title={t`components.table.next-page`}
        >
          <Icon variant="ChevronRight" />
        </Button>
      </ButtonGroup>
    </S.Pagination>
  );
};
